/* eslint-disable no-unused-vars */
/*
Format: -
{
    "type":"ActionBar",
    "align":"left",
    "buttons":[
        {"label":"Specification", "click":"handleShowSpec"},
        {"label":"Formula", "click":"handleShowFormula"},
        {"label":"Process", "click":"handleShowProcess"}
    ]
}

Property "click" call function from app.handlers[] which defined in app root
*/

import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

export function ActionBar(props) {
  const { em, app } = props;
  const { handlers } = app || {};

  const handleDefaultClick = useCallback(
    (e) => {
      if (!handlers) {
        console.error("'handlers' is not found. 'app' property with 'handlers' must be assigned");
        console.info('<ActionBar em={...} app={...} />\nor pass though ZectionGroup');
      }
    },
    [handlers]
  );

  const align = em && em.align && em.align !== '' ? em.align : 'center';
  let barClass = props.className || '';
  if (em.class) barClass += ` ${em.class}`;

  const barProperty = {};
  if (em.id) barProperty.id = em.id;
  if (props.id) barProperty.id = props.id;

  if (em.style) barProperty.style = em.style;
  if (props.style) barProperty.style = props.style;

  return (
    <div className={'row mb-2 ' + (barClass || '')} {...barProperty}>
      <div className={`col-12 text-${align}` + (align==='right' ? ' pr-0' : '')}>
        {em &&
          em.buttons &&
          em.buttons.map((t, i) => {
            if (t.showBy && t.showBy !== '' && typeof app[t.showBy] !== 'undefined' && !app[t.showBy]) return;

            if (t.text) {
              const _style = t.width && t.width!=='' && { display: 'inline-block', width: t.width || '5em' };
              return (
                <span key={i} className={t.class + (t.color ? ` text-${t.color}` : '')} style={_style}>
                  {t.text}
                </span>
              );
            }

            if (!t.label) {
              
              return (
                <span key={i} style={{ display: 'inline-block', width: t.width || '5em' }}>
                  &nbsp;
                </span>
              );
            }

            return (
              <button
                type="button"
                key={i}
                name={t.name}
                onClick={t.click && app.handlers && app.handlers[t.click] ? app.handlers[t.click] : handleDefaultClick}
                className={'btn btn-sm mx-1 btn-' + (t.color || 'info') + (t.icon ? ' btn-icon-split' : '') + ` ${t.class || ''}`}
              >
                {t.icon && (
                  <React.Fragment>
                    <span className="icon text-white">
                      <i className={t.icon}></i>
                    </span>
                    <span className="text d-none d-sm-inline">{t.label}</span>
                  </React.Fragment>
                )}
                {t.icon ? null : t.label}
              </button>
            );
          })}
        {props.children}
      </div>
    </div>
  );
}

ActionBar.defaultProps = {
  em: {},
  app: { lang: 'en', locale: 'en-UK' },
};

ActionBar.propTypes = {
  app : PropTypes.any, 
  em : PropTypes.any,
  id: PropTypes.any,
  className: PropTypes.string,
  children: PropTypes.any,
  style: PropTypes.any,
}